import * as React from 'react';

import { useIntl } from 'react-intl';

import MainLayout from 'src/components/layout/MainLayout';
import { useTitleStore } from 'src/stores/useTitleStore';
import { userMessages } from 'src/features/users/utils/messages';
import Users from 'src/features/users/components/Users';

const UsersLayout = () => {
    const { formatMessage } = useIntl();

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(userMessages.users));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <MainLayout>
            <Users />
        </MainLayout>
    );
};

export default UsersLayout;
